module.exports = __webpack_public_path__ + "img/20210906-1630898316730599.6a236a36.jpg";